export default __webpack_public_path__ + "static/media/3.4ed1f303.webp";